<form nz-form nzLayout="vertical" [formGroup]="formGroup()">
  @if (showTitle()) {
    <h4>{{ 'shared.phoneNumber.header' | translate }}</h4>
  }

  <div nz-row [nzGutter]="32">
    <div nz-col [nzSpan]="24">
      <nz-form-item>
        <nz-form-label
          nzFor="phoneNumber"
          [nzRequired]="required()"
          [nzTooltipTitle]="'shared.phoneNumber.tooltip' | translate"
        >
          {{ labelI18nKey() | translate }}
        </nz-form-label>
        <nz-form-control
          [nzErrorTip]="'shared.phoneNumber.validation' | translate"
        >
          <input
            id="phoneNumber"
            nz-input
            [formControlName]="controlName()"
            [placeholder]="labelI18nKey() | translate"
          />
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>
